import { memo, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import _map from 'lodash/map';
// Local files
import { StyledList } from './BaseAnalysesList.styled';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const BaseAnalysesList = ({ fetchData, getData, isFetching, pagination, renderItem }) => {

  const fetchListData = useCallback((offset) => {
    fetchData({ offset });
  }, [fetchData]);

  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => 
    (scrollTop + 65) >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !isFetching && fetchListData(pagination.limit + pagination.offset);

  return (
    <StyledList onScroll={handleScroll}>
      {_map(getData, (item) => renderItem(item))}
      {isFetching && <ListSkeleton />}
      {getData.length === 0 && !isFetching && <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>No history</Typography>}
    </StyledList>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <BaseAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);